/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  ApkBuild,
  ApkBuildMode,
  ApkInfo,
  ApkUploadTarget,
  BackupFile,
  BackupLastRun,
  BackupTaken,
  HealthAlertTestResult,
  HealthMonitorChannels,
  HikvisionConfig,
  HikvisionSyncResult,
  HikvisionTestResult,
  HikvisionWebhookAccepted,
  PostApiHikvisionWebhookBody,
  PostApkBuildBody,
  PostHikvisionConfigBody,
  PostHikvisionTestBody,
  PostHikvisionWebhookBody,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPostApiHikvisionWebhookUrl = () => {
  return `/api/hikvision/webhook`
}

/**
 * @summary Receive an event pushed by the terminal
 */
export const postApiHikvisionWebhook = async (
  postApiHikvisionWebhookBody?: PostApiHikvisionWebhookBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<HikvisionWebhookAccepted> => {
  return customFetch<HikvisionWebhookAccepted>(getPostApiHikvisionWebhookUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiHikvisionWebhookBody),
  })
}

export const getPostApiHikvisionWebhookMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiHikvisionWebhook>>,
    TError,
    { data?: PostApiHikvisionWebhookBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiHikvisionWebhook>>,
  TError,
  { data?: PostApiHikvisionWebhookBody },
  TContext
> => {
  const mutationKey = ['postApiHikvisionWebhook']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiHikvisionWebhook>>,
    { data?: PostApiHikvisionWebhookBody }
  > = (props) => {
    const { data } = props ?? {}

    return postApiHikvisionWebhook(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiHikvisionWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiHikvisionWebhook>>
>
export type PostApiHikvisionWebhookMutationBody = PostApiHikvisionWebhookBody | undefined
export type PostApiHikvisionWebhookMutationError = unknown

/**
 * @summary Receive an event pushed by the terminal
 */
export const usePostApiHikvisionWebhook = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiHikvisionWebhook>>,
      TError,
      { data?: PostApiHikvisionWebhookBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiHikvisionWebhook>>,
  TError,
  { data?: PostApiHikvisionWebhookBody },
  TContext
> => {
  return useMutation(getPostApiHikvisionWebhookMutationOptions(options), queryClient)
}
export const getPostHikvisionWebhookUrl = () => {
  return `/api/v1/hikvision/webhook`
}

/**
 * @summary Receive an event pushed by the terminal
 */
export const postHikvisionWebhook = async (
  postHikvisionWebhookBody?: PostHikvisionWebhookBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<HikvisionWebhookAccepted> => {
  return customFetch<HikvisionWebhookAccepted>(getPostHikvisionWebhookUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postHikvisionWebhookBody),
  })
}

export const getPostHikvisionWebhookMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHikvisionWebhook>>,
    TError,
    { data?: PostHikvisionWebhookBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postHikvisionWebhook>>,
  TError,
  { data?: PostHikvisionWebhookBody },
  TContext
> => {
  const mutationKey = ['postHikvisionWebhook']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postHikvisionWebhook>>,
    { data?: PostHikvisionWebhookBody }
  > = (props) => {
    const { data } = props ?? {}

    return postHikvisionWebhook(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostHikvisionWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postHikvisionWebhook>>
>
export type PostHikvisionWebhookMutationBody = PostHikvisionWebhookBody | undefined
export type PostHikvisionWebhookMutationError = unknown

/**
 * @summary Receive an event pushed by the terminal
 */
export const usePostHikvisionWebhook = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postHikvisionWebhook>>,
      TError,
      { data?: PostHikvisionWebhookBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postHikvisionWebhook>>,
  TError,
  { data?: PostHikvisionWebhookBody },
  TContext
> => {
  return useMutation(getPostHikvisionWebhookMutationOptions(options), queryClient)
}
export const getPostHikvisionTestUrl = () => {
  return `/api/v1/hikvision/test`
}

/**
 * @summary Check the terminal answers
 */
export const postHikvisionTest = async (
  postHikvisionTestBody?: PostHikvisionTestBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<HikvisionTestResult> => {
  return customFetch<HikvisionTestResult>(getPostHikvisionTestUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postHikvisionTestBody),
  })
}

export const getPostHikvisionTestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHikvisionTest>>,
    TError,
    { data?: PostHikvisionTestBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postHikvisionTest>>,
  TError,
  { data?: PostHikvisionTestBody },
  TContext
> => {
  const mutationKey = ['postHikvisionTest']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postHikvisionTest>>,
    { data?: PostHikvisionTestBody }
  > = (props) => {
    const { data } = props ?? {}

    return postHikvisionTest(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostHikvisionTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postHikvisionTest>>
>
export type PostHikvisionTestMutationBody = PostHikvisionTestBody | undefined
export type PostHikvisionTestMutationError = unknown

/**
 * @summary Check the terminal answers
 */
export const usePostHikvisionTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postHikvisionTest>>,
      TError,
      { data?: PostHikvisionTestBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postHikvisionTest>>,
  TError,
  { data?: PostHikvisionTestBody },
  TContext
> => {
  return useMutation(getPostHikvisionTestMutationOptions(options), queryClient)
}
export const getPostHikvisionSyncUrl = () => {
  return `/api/v1/hikvision/sync`
}

/**
 * @summary Pull everything the terminal has recorded since last time
 */
export const postHikvisionSync = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HikvisionSyncResult> => {
  return customFetch<HikvisionSyncResult>(getPostHikvisionSyncUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostHikvisionSyncMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHikvisionSync>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof postHikvisionSync>>, TError, void, TContext> => {
  const mutationKey = ['postHikvisionSync']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHikvisionSync>>, void> = () => {
    return postHikvisionSync(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostHikvisionSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof postHikvisionSync>>
>

export type PostHikvisionSyncMutationError = unknown

/**
 * @summary Pull everything the terminal has recorded since last time
 */
export const usePostHikvisionSync = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postHikvisionSync>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postHikvisionSync>>, TError, void, TContext> => {
  return useMutation(getPostHikvisionSyncMutationOptions(options), queryClient)
}
export const getGetHikvisionConfigUrl = () => {
  return `/api/v1/hikvision/config`
}

/**
 * @summary The attendance terminal's settings
 */
export const getHikvisionConfig = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HikvisionConfig> => {
  return customFetch<HikvisionConfig>(getGetHikvisionConfigUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetHikvisionConfigQueryKey = () => {
  return [`/api/v1/hikvision/config`] as const
}

export const getGetHikvisionConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getHikvisionConfig>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHikvisionConfig>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetHikvisionConfigQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHikvisionConfig>>> = ({ signal }) =>
    getHikvisionConfig({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHikvisionConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHikvisionConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHikvisionConfig>>
>
export type GetHikvisionConfigQueryError = unknown

export function useGetHikvisionConfig<
  TData = Awaited<ReturnType<typeof getHikvisionConfig>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHikvisionConfig>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHikvisionConfig>>,
          TError,
          Awaited<ReturnType<typeof getHikvisionConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHikvisionConfig<
  TData = Awaited<ReturnType<typeof getHikvisionConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHikvisionConfig>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHikvisionConfig>>,
          TError,
          Awaited<ReturnType<typeof getHikvisionConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHikvisionConfig<
  TData = Awaited<ReturnType<typeof getHikvisionConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHikvisionConfig>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The attendance terminal's settings
 */

export function useGetHikvisionConfig<
  TData = Awaited<ReturnType<typeof getHikvisionConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHikvisionConfig>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHikvisionConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostHikvisionConfigUrl = () => {
  return `/api/v1/hikvision/config`
}

/**
 * @summary Point the system at a terminal
 */
export const postHikvisionConfig = async (
  postHikvisionConfigBody?: PostHikvisionConfigBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<HikvisionConfig> => {
  return customFetch<HikvisionConfig>(getPostHikvisionConfigUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postHikvisionConfigBody),
  })
}

export const getPostHikvisionConfigMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHikvisionConfig>>,
    TError,
    { data?: PostHikvisionConfigBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postHikvisionConfig>>,
  TError,
  { data?: PostHikvisionConfigBody },
  TContext
> => {
  const mutationKey = ['postHikvisionConfig']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postHikvisionConfig>>,
    { data?: PostHikvisionConfigBody }
  > = (props) => {
    const { data } = props ?? {}

    return postHikvisionConfig(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostHikvisionConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof postHikvisionConfig>>
>
export type PostHikvisionConfigMutationBody = PostHikvisionConfigBody | undefined
export type PostHikvisionConfigMutationError = unknown

/**
 * @summary Point the system at a terminal
 */
export const usePostHikvisionConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postHikvisionConfig>>,
      TError,
      { data?: PostHikvisionConfigBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postHikvisionConfig>>,
  TError,
  { data?: PostHikvisionConfigBody },
  TContext
> => {
  return useMutation(getPostHikvisionConfigMutationOptions(options), queryClient)
}
export const getPostHealthMonitorTestUrl = () => {
  return `/api/v1/health-monitor/test`
}

/**
 * @summary Send a test alert down every configured channel
 */
export const postHealthMonitorTest = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthAlertTestResult> => {
  return customFetch<HealthAlertTestResult>(getPostHealthMonitorTestUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostHealthMonitorTestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHealthMonitorTest>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postHealthMonitorTest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postHealthMonitorTest']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postHealthMonitorTest>>,
    void
  > = () => {
    return postHealthMonitorTest(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostHealthMonitorTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postHealthMonitorTest>>
>

export type PostHealthMonitorTestMutationError = unknown

/**
 * @summary Send a test alert down every configured channel
 */
export const usePostHealthMonitorTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postHealthMonitorTest>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postHealthMonitorTest>>, TError, void, TContext> => {
  return useMutation(getPostHealthMonitorTestMutationOptions(options), queryClient)
}
export const getPostBackupsTriggerUrl = () => {
  return `/api/v1/backups/trigger`
}

/**
 * @summary Take a backup now
 */
export const postBackupsTrigger = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BackupTaken> => {
  return customFetch<BackupTaken>(getPostBackupsTriggerUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostBackupsTriggerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackupsTrigger>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof postBackupsTrigger>>, TError, void, TContext> => {
  const mutationKey = ['postBackupsTrigger']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBackupsTrigger>>, void> = () => {
    return postBackupsTrigger(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostBackupsTriggerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackupsTrigger>>
>

export type PostBackupsTriggerMutationError = unknown

/**
 * @summary Take a backup now
 */
export const usePostBackupsTrigger = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postBackupsTrigger>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postBackupsTrigger>>, TError, void, TContext> => {
  return useMutation(getPostBackupsTriggerMutationOptions(options), queryClient)
}
export const getPostApkUploadUrlUrl = () => {
  return `/api/v1/apk/upload-url`
}

/**
 * @summary Where to upload a new build
 */
export const postApkUploadUrl = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ApkUploadTarget> => {
  return customFetch<ApkUploadTarget>(getPostApkUploadUrlUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostApkUploadUrlMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApkUploadUrl>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof postApkUploadUrl>>, TError, void, TContext> => {
  const mutationKey = ['postApkUploadUrl']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApkUploadUrl>>, void> = () => {
    return postApkUploadUrl(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApkUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApkUploadUrl>>
>

export type PostApkUploadUrlMutationError = unknown

/**
 * @summary Where to upload a new build
 */
export const usePostApkUploadUrl = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApkUploadUrl>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postApkUploadUrl>>, TError, void, TContext> => {
  return useMutation(getPostApkUploadUrlMutationOptions(options), queryClient)
}
export const getPostApkUploadDirectUrl = () => {
  return `/api/v1/apk/upload-direct`
}

/**
 * @summary Upload a build
 */
export const postApkUploadDirect = async (
  postApkUploadDirectBody: Blob,
  options?: Parameters<typeof customFetch>[1],
): Promise<ApkInfo> => {
  return customFetch<ApkInfo>(getPostApkUploadDirectUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.android.package-archive', ...options?.headers },
    body: JSON.stringify(postApkUploadDirectBody),
  })
}

export const getPostApkUploadDirectMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApkUploadDirect>>,
    TError,
    { data: Blob },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApkUploadDirect>>,
  TError,
  { data: Blob },
  TContext
> => {
  const mutationKey = ['postApkUploadDirect']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApkUploadDirect>>,
    { data: Blob }
  > = (props) => {
    const { data } = props ?? {}

    return postApkUploadDirect(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApkUploadDirectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApkUploadDirect>>
>
export type PostApkUploadDirectMutationBody = Blob
export type PostApkUploadDirectMutationError = unknown

/**
 * @summary Upload a build
 */
export const usePostApkUploadDirect = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApkUploadDirect>>,
      TError,
      { data: Blob },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApkUploadDirect>>,
  TError,
  { data: Blob },
  TContext
> => {
  return useMutation(getPostApkUploadDirectMutationOptions(options), queryClient)
}
export const getPostApkConfirmUrl = () => {
  return `/api/v1/apk/confirm`
}

/**
 * @summary Confirm what was uploaded
 */
export const postApkConfirm = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ApkInfo> => {
  return customFetch<ApkInfo>(getPostApkConfirmUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostApkConfirmMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApkConfirm>>, TError, void, TContext>
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof postApkConfirm>>, TError, void, TContext> => {
  const mutationKey = ['postApkConfirm']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApkConfirm>>, void> = () => {
    return postApkConfirm(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApkConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof postApkConfirm>>>

export type PostApkConfirmMutationError = unknown

/**
 * @summary Confirm what was uploaded
 */
export const usePostApkConfirm = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApkConfirm>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postApkConfirm>>, TError, void, TContext> => {
  return useMutation(getPostApkConfirmMutationOptions(options), queryClient)
}
export const getPostApkBuildUrl = () => {
  return `/api/v1/apk/build`
}

/**
 * @summary Build the driver app
 */
export const postApkBuild = async (
  postApkBuildBody?: PostApkBuildBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ApkBuild> => {
  return customFetch<ApkBuild>(getPostApkBuildUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApkBuildBody),
  })
}

export const getPostApkBuildMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApkBuild>>,
    TError,
    { data?: PostApkBuildBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApkBuild>>,
  TError,
  { data?: PostApkBuildBody },
  TContext
> => {
  const mutationKey = ['postApkBuild']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApkBuild>>,
    { data?: PostApkBuildBody }
  > = (props) => {
    const { data } = props ?? {}

    return postApkBuild(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApkBuildMutationResult = NonNullable<Awaited<ReturnType<typeof postApkBuild>>>
export type PostApkBuildMutationBody = PostApkBuildBody | undefined
export type PostApkBuildMutationError = unknown

/**
 * @summary Build the driver app
 */
export const usePostApkBuild = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApkBuild>>,
      TError,
      { data?: PostApkBuildBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApkBuild>>,
  TError,
  { data?: PostApkBuildBody },
  TContext
> => {
  return useMutation(getPostApkBuildMutationOptions(options), queryClient)
}
export const getGetHealthMonitorChannelsUrl = () => {
  return `/api/v1/health-monitor/channels`
}

/**
 * An address or a phone number is not enough on its own. The mail credential lives in `loyalty_settings` and the SMS one in `sms_settings`, so the two halves are configured on two different screens and either can be missing.
 * @summary Whether each alert channel can actually carry a message
 */
export const getHealthMonitorChannels = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthMonitorChannels> => {
  return customFetch<HealthMonitorChannels>(getGetHealthMonitorChannelsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetHealthMonitorChannelsQueryKey = () => {
  return [`/api/v1/health-monitor/channels`] as const
}

export const getGetHealthMonitorChannelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getHealthMonitorChannels>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getHealthMonitorChannels>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetHealthMonitorChannelsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealthMonitorChannels>>> = ({
    signal,
  }) => getHealthMonitorChannels({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHealthMonitorChannels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthMonitorChannelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHealthMonitorChannels>>
>
export type GetHealthMonitorChannelsQueryError = unknown

export function useGetHealthMonitorChannels<
  TData = Awaited<ReturnType<typeof getHealthMonitorChannels>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHealthMonitorChannels>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealthMonitorChannels>>,
          TError,
          Awaited<ReturnType<typeof getHealthMonitorChannels>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealthMonitorChannels<
  TData = Awaited<ReturnType<typeof getHealthMonitorChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHealthMonitorChannels>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealthMonitorChannels>>,
          TError,
          Awaited<ReturnType<typeof getHealthMonitorChannels>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealthMonitorChannels<
  TData = Awaited<ReturnType<typeof getHealthMonitorChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHealthMonitorChannels>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether each alert channel can actually carry a message
 */

export function useGetHealthMonitorChannels<
  TData = Awaited<ReturnType<typeof getHealthMonitorChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHealthMonitorChannels>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHealthMonitorChannelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetBackupsUrl = () => {
  return `/api/v1/backups`
}

/**
 * The retention is **24 per database**, not 24 in total: the job runs once per franchise plus central, and each keeps its own history. A three-tenant deployment therefore holds up to 96 files here.
 * @summary The database copies on disk
 */
export const getBackups = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BackupFile[]> => {
  return customFetch<BackupFile[]>(getGetBackupsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetBackupsQueryKey = () => {
  return [`/api/v1/backups`] as const
}

export const getGetBackupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackups>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackups>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBackupsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackups>>> = ({ signal }) =>
    getBackups({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBackups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBackupsQueryResult = NonNullable<Awaited<ReturnType<typeof getBackups>>>
export type GetBackupsQueryError = unknown

export function useGetBackups<TData = Awaited<ReturnType<typeof getBackups>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackups>>,
          TError,
          Awaited<ReturnType<typeof getBackups>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackups<TData = Awaited<ReturnType<typeof getBackups>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackups>>,
          TError,
          Awaited<ReturnType<typeof getBackups>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackups<TData = Awaited<ReturnType<typeof getBackups>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackups>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The database copies on disk
 */

export function useGetBackups<TData = Awaited<ReturnType<typeof getBackups>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackups>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBackupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetBackupsFilenameDownloadUrl = (filename: string) => {
  return `/api/v1/backups/${filename}/download`
}

/**
 * @summary Download one
 */
export const getBackupsFilenameDownload = async (
  filename: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetBackupsFilenameDownloadUrl(filename), {
    ...options,
    method: 'GET',
  })
}

export const getGetBackupsFilenameDownloadQueryKey = (filename: string) => {
  return [`/api/v1/backups/${filename}/download`] as const
}

export const getGetBackupsFilenameDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackupsFilenameDownload>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBackupsFilenameDownload>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBackupsFilenameDownloadQueryKey(filename)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackupsFilenameDownload>>> = ({
    signal,
  }) => getBackupsFilenameDownload(filename, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: filename !== null && filename !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getBackupsFilenameDownload>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetBackupsFilenameDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackupsFilenameDownload>>
>
export type GetBackupsFilenameDownloadQueryError = unknown

export function useGetBackupsFilenameDownload<
  TData = Awaited<ReturnType<typeof getBackupsFilenameDownload>>,
  TError = unknown,
>(
  filename: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBackupsFilenameDownload>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackupsFilenameDownload>>,
          TError,
          Awaited<ReturnType<typeof getBackupsFilenameDownload>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackupsFilenameDownload<
  TData = Awaited<ReturnType<typeof getBackupsFilenameDownload>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBackupsFilenameDownload>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackupsFilenameDownload>>,
          TError,
          Awaited<ReturnType<typeof getBackupsFilenameDownload>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackupsFilenameDownload<
  TData = Awaited<ReturnType<typeof getBackupsFilenameDownload>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBackupsFilenameDownload>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download one
 */

export function useGetBackupsFilenameDownload<
  TData = Awaited<ReturnType<typeof getBackupsFilenameDownload>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBackupsFilenameDownload>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBackupsFilenameDownloadQueryOptions(filename, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetBackupsLastRunUrl = () => {
  return `/api/v1/backups/last-run`
}

/**
 * `ranAt` is null when the job has never run, which is a different state from a run that failed - a screen has to be able to say which. Read from the `backup` entries in `system_logs`, which every run writes whether it succeeds or not.
 * @summary When the backup job last ran, and whether it worked
 */
export const getBackupsLastRun = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BackupLastRun> => {
  return customFetch<BackupLastRun>(getGetBackupsLastRunUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetBackupsLastRunQueryKey = () => {
  return [`/api/v1/backups/last-run`] as const
}

export const getGetBackupsLastRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackupsLastRun>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackupsLastRun>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBackupsLastRunQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackupsLastRun>>> = ({ signal }) =>
    getBackupsLastRun({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBackupsLastRun>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBackupsLastRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackupsLastRun>>
>
export type GetBackupsLastRunQueryError = unknown

export function useGetBackupsLastRun<
  TData = Awaited<ReturnType<typeof getBackupsLastRun>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackupsLastRun>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackupsLastRun>>,
          TError,
          Awaited<ReturnType<typeof getBackupsLastRun>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackupsLastRun<
  TData = Awaited<ReturnType<typeof getBackupsLastRun>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackupsLastRun>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBackupsLastRun>>,
          TError,
          Awaited<ReturnType<typeof getBackupsLastRun>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBackupsLastRun<
  TData = Awaited<ReturnType<typeof getBackupsLastRun>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackupsLastRun>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary When the backup job last ran, and whether it worked
 */

export function useGetBackupsLastRun<
  TData = Awaited<ReturnType<typeof getBackupsLastRun>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBackupsLastRun>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBackupsLastRunQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApkInfoUrl = () => {
  return `/api/v1/apk/info`
}

/**
 * @summary What build is currently published
 */
export const getApkInfo = async (options?: Parameters<typeof customFetch>[1]): Promise<ApkInfo> => {
  return customFetch<ApkInfo>(getGetApkInfoUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetApkInfoQueryKey = () => {
  return [`/api/v1/apk/info`] as const
}

export const getGetApkInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApkInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkInfo>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApkInfoQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApkInfo>>> = ({ signal }) =>
    getApkInfo({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApkInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApkInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getApkInfo>>>
export type GetApkInfoQueryError = unknown

export function useGetApkInfo<TData = Awaited<ReturnType<typeof getApkInfo>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkInfo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkInfo>>,
          TError,
          Awaited<ReturnType<typeof getApkInfo>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkInfo<TData = Awaited<ReturnType<typeof getApkInfo>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkInfo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkInfo>>,
          TError,
          Awaited<ReturnType<typeof getApkInfo>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkInfo<TData = Awaited<ReturnType<typeof getApkInfo>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkInfo>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What build is currently published
 */

export function useGetApkInfo<TData = Awaited<ReturnType<typeof getApkInfo>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkInfo>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApkInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApkDownloadUrl = () => {
  return `/api/v1/apk/download`
}

/**
 * @summary Download the driver app
 */
export const getApkDownload = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetApkDownloadUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetApkDownloadQueryKey = () => {
  return [`/api/v1/apk/download`] as const
}

export const getGetApkDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApkDownload>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkDownload>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApkDownloadQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApkDownload>>> = ({ signal }) =>
    getApkDownload({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApkDownload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApkDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getApkDownload>>>
export type GetApkDownloadQueryError = unknown

export function useGetApkDownload<
  TData = Awaited<ReturnType<typeof getApkDownload>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkDownload>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkDownload>>,
          TError,
          Awaited<ReturnType<typeof getApkDownload>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkDownload<
  TData = Awaited<ReturnType<typeof getApkDownload>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkDownload>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkDownload>>,
          TError,
          Awaited<ReturnType<typeof getApkDownload>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkDownload<
  TData = Awaited<ReturnType<typeof getApkDownload>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkDownload>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the driver app
 */

export function useGetApkDownload<
  TData = Awaited<ReturnType<typeof getApkDownload>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkDownload>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApkDownloadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApiApkDownloadUrl = () => {
  return `/api/apk/download`
}

/**
 * @summary Download the driver app
 */
export const getApiApkDownload = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetApiApkDownloadUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetApiApkDownloadQueryKey = () => {
  return [`/api/apk/download`] as const
}

export const getGetApiApkDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiApkDownload>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiApkDownload>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApiApkDownloadQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiApkDownload>>> = ({ signal }) =>
    getApiApkDownload({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiApkDownload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiApkDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiApkDownload>>
>
export type GetApiApkDownloadQueryError = unknown

export function useGetApiApkDownload<
  TData = Awaited<ReturnType<typeof getApiApkDownload>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiApkDownload>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiApkDownload>>,
          TError,
          Awaited<ReturnType<typeof getApiApkDownload>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiApkDownload<
  TData = Awaited<ReturnType<typeof getApiApkDownload>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiApkDownload>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiApkDownload>>,
          TError,
          Awaited<ReturnType<typeof getApiApkDownload>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiApkDownload<
  TData = Awaited<ReturnType<typeof getApiApkDownload>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiApkDownload>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the driver app
 */

export function useGetApiApkDownload<
  TData = Awaited<ReturnType<typeof getApiApkDownload>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiApkDownload>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiApkDownloadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApkBuildsUrl = () => {
  return `/api/v1/apk/builds`
}

/**
 * @summary Recent builds
 */
export const getApkBuilds = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ApkBuild[]> => {
  return customFetch<ApkBuild[]>(getGetApkBuildsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetApkBuildsQueryKey = () => {
  return [`/api/v1/apk/builds`] as const
}

export const getGetApkBuildsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApkBuilds>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuilds>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApkBuildsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApkBuilds>>> = ({ signal }) =>
    getApkBuilds({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApkBuilds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApkBuildsQueryResult = NonNullable<Awaited<ReturnType<typeof getApkBuilds>>>
export type GetApkBuildsQueryError = unknown

export function useGetApkBuilds<TData = Awaited<ReturnType<typeof getApkBuilds>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuilds>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkBuilds>>,
          TError,
          Awaited<ReturnType<typeof getApkBuilds>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkBuilds<TData = Awaited<ReturnType<typeof getApkBuilds>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuilds>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkBuilds>>,
          TError,
          Awaited<ReturnType<typeof getApkBuilds>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkBuilds<TData = Awaited<ReturnType<typeof getApkBuilds>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuilds>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Recent builds
 */

export function useGetApkBuilds<TData = Awaited<ReturnType<typeof getApkBuilds>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuilds>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApkBuildsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApkBuildIdUrl = (id: string) => {
  return `/api/v1/apk/build/${id}`
}

/**
 * @summary How one build is getting on
 */
export const getApkBuildId = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ApkBuild> => {
  return customFetch<ApkBuild>(getGetApkBuildIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetApkBuildIdQueryKey = (id: string) => {
  return [`/api/v1/apk/build/${id}`] as const
}

export const getGetApkBuildIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApkBuildId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApkBuildIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApkBuildId>>> = ({ signal }) =>
    getApkBuildId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApkBuildId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetApkBuildIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApkBuildId>>>
export type GetApkBuildIdQueryError = unknown

export function useGetApkBuildId<
  TData = Awaited<ReturnType<typeof getApkBuildId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkBuildId>>,
          TError,
          Awaited<ReturnType<typeof getApkBuildId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkBuildId<
  TData = Awaited<ReturnType<typeof getApkBuildId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkBuildId>>,
          TError,
          Awaited<ReturnType<typeof getApkBuildId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkBuildId<
  TData = Awaited<ReturnType<typeof getApkBuildId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How one build is getting on
 */

export function useGetApkBuildId<
  TData = Awaited<ReturnType<typeof getApkBuildId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApkBuildIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApkBuildModeUrl = () => {
  return `/api/v1/apk/build/mode`
}

/**
 * `driverAppPresent` is the field that decides whether a build can run at all - it reports whether the driver app's source directory is on disk. Legacy's client declared the other three fields and not that one, so a client written from it would offer a build button that cannot work.
 * @summary Where a build would run
 */
export const getApkBuildMode = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ApkBuildMode> => {
  return customFetch<ApkBuildMode>(getGetApkBuildModeUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetApkBuildModeQueryKey = () => {
  return [`/api/v1/apk/build/mode`] as const
}

export const getGetApkBuildModeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApkBuildMode>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildMode>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApkBuildModeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApkBuildMode>>> = ({ signal }) =>
    getApkBuildMode({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApkBuildMode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApkBuildModeQueryResult = NonNullable<Awaited<ReturnType<typeof getApkBuildMode>>>
export type GetApkBuildModeQueryError = unknown

export function useGetApkBuildMode<
  TData = Awaited<ReturnType<typeof getApkBuildMode>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildMode>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkBuildMode>>,
          TError,
          Awaited<ReturnType<typeof getApkBuildMode>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkBuildMode<
  TData = Awaited<ReturnType<typeof getApkBuildMode>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildMode>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApkBuildMode>>,
          TError,
          Awaited<ReturnType<typeof getApkBuildMode>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApkBuildMode<
  TData = Awaited<ReturnType<typeof getApkBuildMode>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildMode>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where a build would run
 */

export function useGetApkBuildMode<
  TData = Awaited<ReturnType<typeof getApkBuildMode>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApkBuildMode>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApkBuildModeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
